import request from '@/utils/request'
export function selectAmountByCategory(data) {
    return request({
        url: `api/serviceCenter/orderManagement/selectAmountByCategory`,
        method: 'post',
        data,
    })
}

export function downLoadAmountByCategory(data) {
    return request({
      url: `api/serviceCenter/orderManagement/downLoadAmountByCategory`,
      method: 'post',
      responseType: 'blob',
      data
    })
  }